<script>

    import {OnePageDescription} from "../../../../Modules/index.js";

    let {id: profileID, isActiveProfile: isActive = false} = $props();

</script>

<OnePageDescription id={profileID} entityType="user" {isActive}></OnePageDescription>